import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Upload } from "lucide-react";

export function AttachJdDialog({ open, onOpenChange, onUse }) {
  const [jd, setJd] = useState("");
  const readFile = (file) => {
    if (!file) return;
    if (!/\.(txt|md|text)$/i.test(file.name) && !file.type.startsWith("text/")) { toast.error("Upload a .txt or .md file, or paste the text below"); return; }
    const r = new FileReader();
    r.onload = () => setJd(String(r.result || "").slice(0, 12000));
    r.readAsText(file);
  };
  const use = () => { onUse(jd.trim()); onOpenChange(false); setJd(""); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" data-testid="attach-jd-dialog">
        <DialogHeader>
          <DialogTitle>Start from an existing job description</DialogTitle>
          <DialogDescription>Paste it below. Copilot turns it into a structured role you can review before anything goes live.</DialogDescription>
        </DialogHeader>
        <Textarea value={jd} onChange={(e) => setJd(e.target.value)} rows={10} placeholder="Paste the job description…" data-testid="attach-jd-text" className="resize-none" />
        <label className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground cursor-pointer w-fit">
          <Upload className="h-4 w-4" /> Or upload a .txt file
          <input type="file" accept=".txt,.md,text/plain" className="sr-only" onChange={(e) => readFile(e.target.files?.[0])} data-testid="attach-jd-file" />
        </label>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={use} disabled={jd.trim().length < 40} data-testid="attach-jd-use">Draft the role</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
